import React, { useEffect } from 'react';
import './Support.css';

const Support: React.FC = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleDiscordClick = () => {
    window.open('https://discord.gg/ZFZ3aaH3vt', '_blank');
  };

  const handleEmailClick = () => {
    window.open('mailto:support@glassedgesoftware.com?subject=Gym Edge Support Request', '_blank');
  };

  return (
    <div className="support-container">
      <div className="support-header">
        <h1>Support & Help</h1>
      </div>

      <div className="support-content">
        <div className="contact-section">
          <p className="contact-intro">
            Need help or have questions? We offer two ways to get in touch with our support team:
          </p>

          <div className="contact-methods">
            <div className="contact-method preferred">
              <div className="contact-icon discord-icon">💬</div>
              <h3>Discord Community</h3>
              <p className="method-description">
                Join our Discord server for real-time support, community discussions, 
                and direct access to our development team.
              </p>
              <div className="method-benefits">
                <ul>
                  <li>Fastest response times</li>
                  <li>Community support from other users</li>
                  <li>Early access to updates and beta features</li>
                  <li>Direct feedback to developers</li>
                </ul>
              </div>
              <button 
                className="contact-button discord-button"
                onClick={handleDiscordClick}
              >
                Join Discord Server
              </button>
              <p className="preferred-label">Preferred Support Method</p>
            </div>

            <div className="contact-method">
              <div className="contact-icon email-icon">📧</div>
              <h3>Email Support</h3>
              <p className="method-description">
                Send us an email for detailed support requests, bug reports, 
                or privacy-related inquiries.
              </p>
              <div className="method-benefits">
                <ul>
                  <li>Detailed written responses</li>
                  <li>Perfect for complex issues</li>
                  <li>Privacy and account-related matters</li>
                  <li>Formal support documentation</li>
                </ul>
              </div>
              <button 
                className="contact-button email-button"
                onClick={handleEmailClick}
              >
                Send Email
              </button>
              <p className="email-address">support@glassedgesoftware.com</p>
            </div>
          </div>
        </div>

        <div className="support-tips-section">
          <h2>Before Contacting Support</h2>
          <div className="tips-grid">
            <div className="tip-card">
              <h4>Include App Information</h4>
              <p>Let us know which version you're using and your device type.</p>
            </div>
            <div className="tip-card">
              <h4>Describe the Issue</h4>
              <p>Provide clear details about what you were trying to do and what happened instead.</p>
            </div>
            <div className="tip-card">
              <h4>Screenshots Help</h4>
              <p>If possible, include screenshots or screen recordings of the issue you're experiencing.</p>
            </div>
            <div className="tip-card">
              <h4>Try Basic Troubleshooting</h4>
              <p>Restart the app, check for updates, or try clearing the app cache if you're experiencing issues.</p>
            </div>
          </div>
        </div>

        <div className="response-time-section">
          <h2>Response Times</h2>
          <div className="response-times">
            <div className="response-time">
              <h4>Discord Support</h4>
              <p><strong>Typically:</strong> Within a few hours during business hours</p>
              <p><strong>Community:</strong> Often immediate responses from other users</p>
            </div>
            <div className="response-time">
              <h4>Email Support</h4>
              <p><strong>Typically:</strong> 24-48 hours</p>
              <p><strong>Complex Issues:</strong> May take up to 72 hours</p>
            </div>
          </div>
        </div>

        <div className="alpha-notice-section">
          <h2>Early Version Notice</h2>
          <div className="alpha-notice">
            <p>
              <strong>Thank you for using our early app version!</strong> Your feedback is invaluable in helping us 
              create the best fitness tracking experience possible. As an early version:
            </p>
            <ul>
              <li>Some features may be incomplete or change significantly</li>
              <li>You might encounter bugs or unexpected behavior</li>
              <li>Data backup and export features are limited</li>
              <li>Regular updates may reset certain app settings</li>
            </ul>
            <p>
              We appreciate your patience and feedback as we progress through our development journey.
            </p>
          </div>
        </div>

      </div>

    </div>
  );
};

export default Support;